
import "./CounterSection.css"; 

const CounterSection = () => {
  const counters = [
    { value: "1000+", label: "Years of combined experience" },
    { value: "550+", label: "Clients served since 2012" },
    { value: "65+", label: "Finance Professionals" },
    { value: "40+", label: "CFOs" },
    { value: "13", label: "Years in the business" },
  ];

  return (
    <section className="counter-sec">
      <img
        alt="Dubai Background"
        src="https://cfobridge.com/assets/images/pt.svg"
      />
      <div className="container">
        <div className="counter-header">
          <h2 className="counter-main-title">
            Premier Outsourced CFO Services Provider
          </h2>
        </div>

        <div className="counter-container">
          {counters.map((item, index) => (
            <div className="count-wrap" key={index}>
              <h2>
                <span>{item.value}</span>
              </h2>
              <p>{item.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CounterSection;
